export const peopleContent = {
  title: "Our People",
  headline: "Clarity, Efficiency, Human Expertise.",
  intro: "Hungerford Provides the Best Estimators in the Industry",

  images: [
    {
      imageSrc: "/assets/team/image77.jpg",
      imageAlt: "Team working together",
    },
    {
      imageSrc: "/assets/team/image1.jpg",
      imageAlt: "Construction planning",
    },
  ],

  description1: `Founded in Toronto in 2018 by Daniel Hungerford-Morgan, Hungerford has grown from one estimator into a platform for the industry’s best.
We deliver top estimators backed with disciplined systems, accurate reviews, and accountable results across estimating and preconstruction. Our estimators integrate seamlessly into client teams with clean handoffs and little oversight. We work hand in hand with owners, GCs, subs, and vendors to deliver clean scopes and defensible numbers, aligned to budget, schedule, and stakeholders, so projects exceed expectations without excess.`,
  team: [
    {
      name: "Daniel Hungerford-Morgan",
      role: "Founder",
      bio: `Daniel, the visionary founder of our company, he is a civil engineer turned  master  systems  builder  whose  leadership  is  transforming   the  construction   industry.  He has revolutionized workflows for over 75 contracting companies, designing systems that emphasize disciplined estimating, accountable project delivery, and reliable execution. Daniel’s strategic foresight and hands-on expertise empower our team and clients to succeed in complex projects.
                  `,
      imageSrc: "/assets/ing/daniel.jpg",
      imageAlt: "Daniel Hungerford-Morgan",
    },
    {
      name: "Giulia Mammi",
      role: "HR Manager",
      bio: `Giulia, our dedicated People and Culture leader, has played a pivotal role in building the foundation of our organization. From our earliest days, she has guided our team’s growth into a thriving group of over 15 professionals. Through her empathetic leadership and passion for collaboration, Giulia has fostered an exceptional and inclusive culture that drives excellence. She ensures our team flourishes in an environment where everyone feels empowered to contribute to our shared success.`,
      imageSrc: "/assets/ing/giulia.jpg",
      imageAlt: "Giulia Mammi",
    },
    {
      name: "Francis Wardley",
      role: "Lead Developer",
      bio: `Francis, our accomplished Software Lead, brings a wealth of experience from leading tech roles across Europe to drive innovation at our company. From day one, he has led the development of our estimating platform, Cango, crafting a transformative solution that’s redefining construction processes. With a deep understanding of on-site challenges, Francis delivers clean, reliable, and revolutionary technology that empowers contractors to achieve unmatched efficiency and accuracy.`,
      imageSrc: "/assets/ing/francis.jpg",
      imageAlt: "Francis Wardley",
    },
    {
      name: "Nathan Fernandes",
      role: "Head of Estimating",
      bio: "As Estimating Team Lead, Nathan brings over a decade of experience in construction, community development design, and public sector initiatives. For the past five years, he has focused on building a robust heavy civil estimating system, delivering accurate cost estimates for more than 50 contractors on projects totaling over $500 million. Nathan is committed to precision and excellence, fostering collaboration to ensure every project achieves outstanding results.",
      imageSrc: "/assets/ing/nathan.jpg",
      imageAlt: "Nathan Fernandes",
    },
    {
      name: "Mark Wodz",
      role: "Estimating Lead",
      bio: "As Senior Estimator, Mark brings extensive experience in heavy civil construction, with a track record of delivering accurate estimates on projects totaling over $750 million. He is deeply committed to precision and excellence, as well as to mentoring and training the next generation of skilled estimators. Mark has created a collaborative environment where knowledge is shared and high standards are upheld, ensuring every project is set up for accuracy and success.",
      imageSrc: "/assets/ing/markc.jpg",
      imageAlt: "Mark Wodz",
    },
    {
      name: "David Nunez",
      role: "System Engineer",
      bio: "David brings a wealth of technical expertise to our team, with four years of experience designing and implementing systems for more than 20 companies. He now focuses on building the workflows and databases that form the backbone of our estimating operations. With a sharp eye for process optimization and a passion for precision, David ensures our systems run seamlessly, empowering our team to deliver accurate, efficient results.",
      imageSrc: "/assets/ing/david.jpg",
      imageAlt: "David",
    },
    {
      name: "Spencer Oliver",
      role: "Marketing & Sales",
      bio: "Spencer, a skilled marketing professional, leads our marketing initiatives with creativity and precision. He has delivered tailored estimating solutions to over 40 companies, leveraging his expertise in crafting compelling Facebook campaigns and fostering meaningful client relationships. With a strategic focus, Spencer ensures the right contractors discover the ideal solutions at exactly the right time.",
      imageSrc: "/assets/ing/spencer.jpg",
      imageAlt: "Spencer Oliver",
    },
  ],
};
